/**
 * Modal sửa tin BĐS — load AdminPropertyForm theo propertyId.
 */
import { AdminPropertyForm } from './AdminPropertyForm';
import { AdminModal } from './AdminModal';
import { TEXT } from '../../shared/languages';

const CloseIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true">
    <path d="M6 6l12 12M18 6L6 18" strokeLinecap="round" />
  </svg>
);

/**
 * Modal chỉnh sửa BĐS.
 * @param {Object} props
 * @param {number|string|null} props.propertyId
 * @param {boolean} [props.isOpen]
 * @param {boolean} props.canReviewProperty
 * @param {string} props.userRole
 * @param {Function} props.onClose
 * @param {Function} props.onSaved
 */
export const AdminPropertyEditModal = ({
  propertyId,
  isOpen = Boolean(propertyId),
  canReviewProperty = false,
  userRole,
  onClose,
  onSaved,
}) => {
  const form = TEXT.property.form;
  const common = TEXT.common;

  return (
    <AdminModal
      isOpen={isOpen}
      onClose={onClose}
      panelClassName="admin-form-modal admin-form-modal--sheet"
      ariaLabelledby="admin-property-edit-title"
    >
      <div className="admin-form-modal-header admin-form-sheet-header">
        <div className="admin-form-sheet-handle" aria-hidden="true" />
        <div className="admin-form-sheet-header-row">
          <div>
            <span className="eyebrow">{form.editEyebrow}</span>
            <h2 id="admin-property-edit-title">{form.editTitle}</h2>
          </div>
          <button
            type="button"
            className="admin-form-sheet-close"
            aria-label={common.close}
            onClick={onClose}
          >
            <CloseIcon />
          </button>
        </div>
      </div>

      {isOpen && propertyId && (
        <AdminPropertyForm
          key={propertyId}
          formId={`admin-property-edit-form-${propertyId}`}
          propertyId={propertyId}
          canReviewProperty={canReviewProperty}
          userRole={userRole}
          onSaved={onSaved}
          sheetLayout
        />
      )}
    </AdminModal>
  );
};
